import { useEffect, useState } from 'react';

/**
 * スクロールに追従して、現在ビューポート上部に最も近い見出し id を返す。
 * MUI ドキュメントの右ペイン目次と同じ挙動（scrollspy）。
 *
 * @param ids 監視対象の要素 id 配列
 * @param scrollContainer スクロールするコンテナ（省略時は window）
 */
export const useScrollSpy = (ids: string[], scrollContainer?: HTMLElement | null): string => {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    if (ids.length === 0) return;

    const container = scrollContainer ?? undefined;

    const onScroll = () => {
      // コンテナ上端から見て、上端を超えた（または最も近い）見出しを active にする
      const offsetTop = container ? container.getBoundingClientRect().top : 0;
      let current = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top - offsetTop;
        // 上端から 120px 以内に来たらアクティブ扱い
        if (top <= 120) {
          current = id;
        } else {
          break;
        }
      }
      setActiveId(current);
    };

    const target: HTMLElement | Window = container ?? window;
    target.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => target.removeEventListener('scroll', onScroll);
  }, [ids, scrollContainer]);

  return activeId;
};
